import CustomSpinner from "components/Atoms/CustomSpinner"
import SubHeader from "components/Organisms/SubHeader"
import { useRouteDetailLazyQuery } from "generated/graphql"
import useRouteStore from "pages/fsm/routes.store"
import React, { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import OutletListFooter from "./OutletListFooter"
import RouteDetailView from "./RouteDetailView"
const RouteDetailPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const reset = useRouteStore(store => store.reset)
  const [fetch, { data, loading }] = useRouteDetailLazyQuery()
  useEffect(() => {
    if (parseInt(id)) {
      fetch({ variables: { id } })
    }

    return function cleanup() {
      reset()
    }
  }, [fetch, id])

  if (loading) return <CustomSpinner />

  return (
    <SubHeader
      className="p-0"
      breadrumbs={[
        {
          href: "/d/fsm/routes",
          text: "Routes",
          onClick(e) {
            e.preventDefault()
            navigate("/d/fsm/routes")
          },
        },
        {
          href: `/d/fsm/routes/${id}`,
          text: data?.routeDetail?.name || id,
          onClick(e) {
            e.preventDefault()
            navigate(`/d/fsm/routes/${id}`)
          },
        },
      ]}
    >
      <RouteDetailView route={data?.routeDetail}>
        <OutletListFooter />
      </RouteDetailView>
    </SubHeader>
  )
}

export default RouteDetailPage
